/** @prettier */

/**
 * ログイン画面のフッター
 */

import Grid from '@mui/material/Grid';

const LoginFooter = () => {
  return (
    <Grid container className="loginMain__leftFrame__footer">
      <Grid item xs={9}>
        © Mitsubishi Heavy Industries Thermal Systems, Ltd.
      </Grid>
      <Grid item xs={3} className="loginMain__leftFrame__footer__version">
        VERSION:2.4
      </Grid>
    </Grid>
  );
};
export default LoginFooter;
